/*  FGO HOME v4 — behaviour  (22 Sep 2026)

    Ported from pdp/design/beam-home/index.html. Three changes from the
    prototype, all forced by the move into Shopify sections:

    1. THE PROTOTYPE BOUND TO FIXED ids (#cards, #rrow, #cprev). A theme
       section can be added twice, reordered, or removed in the editor, so
       everything here binds by CLASS across the document and pairs buttons to
       their row through data-h4-prev="<row id>". The PDP shipped with the
       opposite bug — JS bound to the first of nine roots — and it cost an
       afternoon.

    2. EVERY BIND IS IDEMPOTENT. Shopify re-renders one section at a time in
       the editor and fires shopify:section:load; without a guard the second
       render leaves two click handlers on the same button and the carousel
       jumps two tiles.

    3. THE CAROUSEL'S OPENING TILE IS DERIVED, NOT HARDCODED TO 2. The
       prototype had three tiles; a merchant can add ten.
*/
(function () {
  'use strict';

  /* Each v4 section emits its own <script src> for this file (see
     fgo-h4-icons.liquid for why), so this runs once per section. Everything
     below is idempotent anyway, but there is no reason to do it ten times. */
  if (window.__fgoH4) return;
  window.__fgoH4 = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Motion preference is read per call rather than cached: a visitor can change
     it mid-session, and the carousel is the one thing on this page that moves
     far enough for that to matter. */
  function beh() {
    return (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';
  }

  function once(el, key) {
    if (!el || el.getAttribute(key) === '1') return false;
    el.setAttribute(key, '1');
    return true;
  }

  /* ---------------------------------------------------------------- accordion
     One row open per group, both directions animated by the CSS. The button
     carries aria-expanded; the .open class is only for the animation. */
  function accordions(root) {
    $$('[data-acc-group]', root).forEach(function (group) {
      if (!once(group, 'data-h4-acc-bound')) return;
      var items = $$('[data-acc]', group);
      items.forEach(function (it) {
        var b = $('.acc-btn', it);
        if (!b) return;
        b.addEventListener('click', function () {
          var wasOpen = it.classList.contains('open');
          items.forEach(function (o) {
            o.classList.remove('open');
            var ob = $('.acc-btn', o);
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            it.classList.add('open');
            b.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* -------------------------------------------------------------- scroll rows
     Arrow keys move one card, but only when the row actually overflows —
     otherwise the keys are stolen from the page for no reason. */
  function rows(root) {
    $$('.srow', root).forEach(function (row) {
      if (!once(row, 'data-h4-row-bound')) return;
      if (row.classList.contains('rrow')) return;   /* the carousel below owns its own keys */
      row.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (row.scrollWidth <= row.clientWidth) return;
        row.scrollBy({ left: e.key === 'ArrowRight' ? stepOf(row) : -stepOf(row), behavior: beh() });
        e.preventDefault();
      });
    });
  }

  function stepOf(row) {
    var c = row.querySelector('.pcard, .tile, .rtile, li');
    if (!c) return 300;
    var w = c.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || '16');
    return w + (isNaN(gap) ? 16 : gap);
  }

  /* ------------------------------------------------------------ prev / next
     Paired to a row by id so two sellers rows on one page cannot drive each
     other. Buttons disable at the ends rather than clicking into nothing. */
  function nav(root) {
    $$('[data-h4-prev], [data-h4-next]', root).forEach(function (btn) {
      if (!once(btn, 'data-h4-nav-bound')) return;
      var id = btn.getAttribute('data-h4-prev') || btn.getAttribute('data-h4-next');
      var back = btn.hasAttribute('data-h4-prev');
      var row = document.getElementById(id);
      if (!row) return;

      /* a carousel row steps tile by tile through its own go(); a plain row scrolls */
      btn.addEventListener('click', function () {
        if (row.h4step) { row.h4step(back ? -1 : 1); return; }
        row.scrollBy({ left: back ? -stepOf(row) : stepOf(row), behavior: beh() });
      });

      var upd = function () {
        var was = btn.disabled;
        /* the start is where the FIRST card snaps, not 0: the Best sellers
           rail rests at 40 (its padding), so Prev never disabled there */
        var startX = 0, first = row.firstElementChild;
        if (first) {
          var sp = parseFloat(getComputedStyle(row).scrollPaddingLeft) || 0;
          startX = Math.max(0, first.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - sp);
        }
        btn.disabled = back
          ? row.scrollLeft <= startX + 4
          : row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
        /* a keyboard user who presses Next to the end must not be dropped on
           the body when the button disables under them: hand focus across */
        if (btn.disabled && !was && document.activeElement === btn) {
          var other = document.querySelector('[data-h4-' + (back ? 'next' : 'prev') + '="' + id + '"]');
          if (other && !other.disabled) other.focus({ preventScroll: true });
        }
      };
      row.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* -------------------------------------------------------- reviews rail
     THE REVIEWS RAIL, REBUILT (23 Sep 2026). See fgo-home-v4.css note 72 for
     what the old one measured like. The browser owns every gesture it is good
     at -- trackpad, wheel, touch, momentum, the phone's snap -- and this only
     adds what a scroller lacks:
       - arrow/key steps of ONE tile (Brightland's rhythm) on an eased glide
         that is VELOCITY-CONTINUOUS: a second click, a key held down or a flick
         hands its current speed to the next glide, so nothing stalls or surges;
       - desktop mouse drag with a flick, landing on a tile edge; the click
         after a drag is swallowed so a drag never opens a product;
       - a six-step position indicator on phones;
       - keys and tab focus that land on tile edges.
     It never moves the rail after the visitor lets go of it, and a resize only
     re-aligns when the WIDTH changed (a phone toolbar hiding is a height change
     and used to rewind the rail). Round 2 fixes (verify pass, 23 Sep): a press
     released off the rail left a drag armed that scrolled with a bare cursor
     and disabled every "+" link; glides restarted from a stall; vertical wheels
     and plain clicks killed a glide mid-way. */
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    return function (x) {
      var t = x, i, e, d;
      for (i = 0; i < 8; i++) {
        e = ((ax * t + bx) * t + cx) * t - x;
        d = (3 * ax * t + 2 * bx) * t + cx;
        if (Math.abs(e) < 1e-5 || Math.abs(d) < 1e-6) break;
        t -= e / d;
      }
      t = Math.max(0, Math.min(1, t));
      return ((ay * t + by) * t + cy) * t;
    };
  }
  /* from rest: 48 / 85 / 97% at a quarter / half / three quarters -- Brightland's
     calm landing (CSS 'ease', 41 / 80 / 96) without its slow start */
  var glideEase = bezier(0.3, 0.3, 0.2, 1);
  /* in motion: a cubic that starts at slope s (the speed it already has) and
     lands at zero speed -- monotone for 0 <= s <= 3 */
  function carry(s) {
    return function (k) { return s * (k * k * k - 2 * k * k + k) + (3 * k * k - 2 * k * k * k); };
  }

  function carousels(root) {
    $$('.rrow', root).forEach(function (row) {
      if (!once(row, 'data-h4-car-bound')) return;
      if (!$$('.rtile', row).length) return;
      var sec = row.closest('.reviews') || row.parentNode;
      var reduce = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
      var live = function () { return $$('.rtile', row).filter(function (t) { return t.offsetParent !== null; }); };
      var real = $$('.rtile', row).filter(function (t) { return !t.hasAttribute('data-h4-copy'); }).length || 1;
      var maxX = function () { return Math.max(0, row.scrollWidth - row.clientWidth); };
      var clampX = function (x) { return Math.max(0, Math.min(maxX(), x)); };

      /* where each tile's left edge meets the gutter; the last ones clamp to
         the end of the rail, so the end is a real stop, not a void. Cached --
         read on every scroll frame by the indicator -- and dropped on resize. */
      var cache = null;
      var points = function () {
        if (cache) return cache;
        var p = parseFloat(getComputedStyle(row).paddingLeft) || 0, m = maxX(), out = [];
        live().forEach(function (t) {
          var v = Math.min(m, Math.max(0, t.offsetLeft - p));
          if (!out.length || v - out[out.length - 1] > 1) out.push(v);
        });
        /* a last stop closer than half a tile to the one before it is a runt
           (1556-1759px: the last click crept 2-104px): the end is one click */
        var lt = live()[0];
        var pitch = lt ? lt.offsetWidth + (parseFloat(getComputedStyle(row).columnGap) || 16) : 0;
        while (out.length > 1 && out[out.length - 1] - out[out.length - 2] < pitch / 2) out.splice(out.length - 2, 1);
        cache = out.length ? out : [0];
        return cache;
      };
      var nearest = function (x, pts) {
        var i, best = 0;
        for (i = 1; i < pts.length; i++) if (Math.abs(pts[i] - x) < Math.abs(pts[best] - x)) best = i;
        return best;
      };

      /* ---- the glide ----
         Timed on the display's REAL frames. A retarget (a second click, a key
         held down) starts from the frame the visitor last saw -- its position,
         its speed, its timestamp -- so the next frame advances exactly one
         frame of travel at 60, 120 or 165Hz alike. (Round 2 assumed 16ms
         frames: on a 165Hz screen every retarget surged, then dropped ~50%.) */
      var anim = null, raf = null, lastFrameT = 0;
      var velocityAt = function (t) {
        if (!anim || anim.t0 === null) return 0;
        var k = (t - anim.t0) / anim.dur;
        if (k < 0 || k >= 1) return 0;
        var k2 = Math.min(1, k + 0.02);
        return anim.dist * (anim.ease(k2) - anim.ease(k)) / ((k2 - k) * anim.dur);
      };
      var stop = function () {
        if (raf) cancelAnimationFrame(raf);
        raf = null; anim = null;
        row.classList.remove('is-gliding');
      };
      var glide = function (to, v0) {
        to = clampX(to);
        if (reduce()) { stop(); row.scrollLeft = to; return; }
        var moving = !!(anim && anim.t0 !== null && lastFrameT);
        var tRef = moving ? lastFrameT : null;
        /* a flick hands over from the drag's last painted frame, not from the
           release event (which runs after that frame has already started) */
        if (!moving && typeof v0 === 'number' && Math.abs(v0) > 0.05 && lastFrameT && performance.now() - lastFrameT < 50) tRef = lastFrameT;
        var v = typeof v0 === 'number' ? v0 : (moving ? velocityAt(tRef) : 0);
        var from = row.scrollLeft, dist = to - from;
        if (Math.abs(dist) < 1) { stop(); return; }
        /* a swipe still settling into its snap would fight the glide: park it */
        if (!anim) { try { row.scrollTo({ left: from, behavior: 'instant' }); } catch (err) {} }
        var dur = Math.max(480, Math.min(780, 400 + Math.abs(dist) * 0.2)), ease;
        if (Math.abs(v) > 0.05) {
          /* keep the speed it has; if that speed would overshoot, land sooner
             (down to 120ms) rather than cut the speed at the handoff */
          var s = v * dur / dist;
          if (s > 2.8) { dur = Math.max(120, 2.8 * dist / v); s = Math.min(3, v * dur / dist); }
          if (s < -1.2) s = -1.2;                      /* against the motion: ease through, don't whip */
          ease = carry(s);
        } else {
          ease = glideEase;
        }
        if (raf) cancelAnimationFrame(raf);
        /* from rest the clock starts at the click itself, so the first frame
           moves exactly the time that has really passed (a page-load probe of
           the frame rate read slow frames and made the first frame jump) */
        anim = { from: from, dist: dist, dur: dur, t0: tRef, ease: ease, to: to, called: performance.now() };
        row.classList.add('is-gliding');
        var frame = function (t) {
          if (!anim) return;
          if (anim.t0 === null) anim.t0 = Math.min(anim.called, t);
          var k = Math.max(0, Math.min(1, (t - anim.t0) / anim.dur));
          row.scrollLeft = anim.from + anim.dist * anim.ease(k);
          lastFrameT = t;
          if (k < 1) { raf = requestAnimationFrame(frame); }
          else { raf = null; anim = null; row.classList.remove('is-gliding'); }
        };
        raf = requestAnimationFrame(frame);
      };

      /* the rail moving on its own (a swipe settling into its snap) */
      var lastX = row.scrollLeft, lastT = 0, lastDx = 0;
      row.addEventListener('scroll', function () {
        if (!anim) { lastT = performance.now(); lastDx = row.scrollLeft - lastX; }
        lastX = row.scrollLeft;
      }, { passive: true });

      /* one tile per step. During a glide the step counts from where it is
         heading; while a swipe is still settling, from where the snap is taking
         it; from a free rest position (a trackpad can leave it anywhere), Next
         goes to the next edge and Prev to the one before. */
      row.h4step = function (dir) {
        var pts = points(), i = 0, k, at;
        if (anim) at = anim.to;
        else if (performance.now() - lastT < 90 && lastDx) at = pts[nearest(row.scrollLeft + lastDx * 10, pts)];
        else at = row.scrollLeft;
        for (k = 0; k < pts.length; k++) if (pts[k] <= at + 2) i = k;
        var onEdge = Math.abs(pts[i] - at) <= 2;
        var to = dir > 0 ? i + 1 : (onEdge ? i - 1 : i);
        to = Math.max(0, Math.min(pts.length - 1, to));
        if (anim && Math.abs(anim.to - pts[to]) < 1) return;   /* already going there */
        glide(pts[to]);
      };

      row.addEventListener('keydown', function (e) {
        if (!row.contains(e.target)) return;
        if (e.key === 'ArrowRight') { row.h4step(1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { row.h4step(-1); e.preventDefault(); }
      });
      /* tabbing into a tile's "+" lands that tile on the gutter, not wherever
         the browser's own focus scroll left it */
      var preTab = null;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') preTab = { x: row.scrollLeft, t: performance.now() };
      }, true);
      row.addEventListener('focusin', function (e) {
        var t = e.target !== row && e.target.closest && e.target.closest('.rtile');
        var jumped = preTab && performance.now() - preTab.t < 400 ? preTab.x : null;
        preTab = null;
        if (!t || t.offsetParent === null) return;
        /* the browser has already jumped the rail to show the link; put it back
           where the visitor saw it, then glide the tile onto the gutter */
        if (jumped !== null && !anim && Math.abs(row.scrollLeft - jumped) > 1) row.scrollLeft = jumped;
        var p = parseFloat(getComputedStyle(row).paddingLeft) || 0;
        var edge = clampX(t.offsetLeft - p);
        var left = row.scrollLeft, right = left + row.clientWidth - 2 * p;
        var pts = points(), onStop = Math.abs(pts[nearest(left, pts)] - left) <= 2;
        var clipped = t.offsetLeft - p < left - 1 || t.offsetLeft - p + t.offsetWidth > right + 1;
        if (clipped || !onStop) glide(edge, 0);
      });

      /* a hand on the rail wins over a glide -- but only a HORIZONTAL hand: a
         vertical wheel over the rail is someone scrolling the page */
      row.addEventListener('wheel', function (e) {
        if (anim && (Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.shiftKey)) stop();
      }, { passive: true });
      row.addEventListener('touchstart', function () { if (anim) stop(); }, { passive: true });

      /* ---- desktop mouse drag (touch and trackpads scroll natively) ----
         The move/up listeners live on WINDOW for the life of a press, so a
         release anywhere ends it; a move with no button held ends it too. */
      var drag = null, swallow = false;
      var onMove = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        if (e.buttons === 0) { onUp(e); return; }
        var dx = e.clientX - drag.x0;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          drag.moved = true;
          if (anim) stop();
          (function track(t) { if (!drag) return; if (t) lastFrameT = t; requestAnimationFrame(track); }());
          drag.left = row.scrollLeft; drag.x0 = e.clientX; dx = 0;
          row.classList.add('is-dragging');
        }
        row.scrollLeft = drag.left - dx;
        var now = performance.now(), dt = now - drag.lt;
        if (dt > 0) {
          var v = (drag.lx - e.clientX) / dt;           /* px/ms, + = towards the end */
          drag.v = drag.v * 0.25 + v * 0.75;
          drag.lx = e.clientX; drag.lt = now;
        }
      };
      var onUp = function (e) {
        if (!drag || (e && e.pointerId !== undefined && e.pointerId !== drag.id)) return;
        var d = drag; drag = null;
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        row.classList.remove('is-dragging');
        if (!d.moved) return;                            /* a plain press: any glide carries on */
        swallow = true; setTimeout(function () { swallow = false; }, 60);
        /* a flick carries: project ~260ms of the release speed, settle on the
           nearest tile edge, and hand the release speed to that glide */
        var still = performance.now() - d.lt > 90;
        var v = still ? 0 : d.v;
        var pts = points();
        glide(pts[nearest(row.scrollLeft + v * 260, pts)], v);
      };
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });
      row.addEventListener('pointerdown', function (e) {
        row.classList.remove('is-dragging');
        if (e.pointerType !== 'mouse' || e.button !== 0 || window.innerWidth <= 1024) return;
        if (drag) onUp();
        drag = { id: e.pointerId, x0: e.clientX, left: row.scrollLeft, lx: e.clientX, lt: performance.now(), v: 0, moved: false };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      });
      row.addEventListener('click', function (e) {
        if (swallow) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* ---- the phone indicator: one step per REAL review; the repeated
         copies wrap it round, the way the list itself wraps ---- */
      var bar = $('[data-h4-rbar]', sec), segs = [];
      if (bar) {
        bar.textContent = '';
        for (var n = 0; n < real; n++) { var s = document.createElement('i'); bar.appendChild(s); segs.push(s); }
      }
      var queued = false, onSeg = -1;
      var draw = function () {
        queued = false;
        if (!segs.length) return;
        var i = nearest(row.scrollLeft, points()) % real;
        if (i === onSeg) return;
        if (onSeg >= 0 && segs[onSeg]) segs[onSeg].classList.remove('on');
        segs[i].classList.add('on'); onSeg = i;
      };
      row.addEventListener('scroll', function () {
        if (!queued) { queued = true; requestAnimationFrame(draw); }
      }, { passive: true });
      draw();

      /* ---- photos: a horizontal rail defeats lazy loading (the last tiles are
         off to the side, not below), so load them all as the rail approaches ---- */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es.some(function (x) { return x.isIntersecting; })) return;
          $$('img[loading="lazy"]', row).forEach(function (im) { im.loading = 'eager'; });
          io.disconnect();
        }, { rootMargin: '800px 0px' });
        io.observe(row);
      }

      /* ---- width changes keep the tile you were on; height changes do nothing ---- */
      var lastW = window.innerWidth, idx = 0;
      var remember = function () { if (window.innerWidth !== lastW) return; idx = nearest(row.scrollLeft, points()); };
      if ('onscrollend' in window) row.addEventListener('scrollend', remember);
      else row.addEventListener('scroll', function () { clearTimeout(row.h4rm); row.h4rm = setTimeout(remember, 150); }, { passive: true });
      var rz;
      window.addEventListener('resize', function () {
        if (window.innerWidth !== lastW) cache = null;
        clearTimeout(rz);
        rz = setTimeout(function () {
          if (window.innerWidth === lastW) return;
          lastW = window.innerWidth;
          stop(); cache = null;
          var pts = points();
          row.scrollLeft = pts[Math.min(idx, pts.length - 1)];
          onSeg = -1; draw();
        }, 120);
      });

      /* ---- auto-advance: OFF by default since 23 Sep; kept for the setting ----
         Desktop only, one tile at a time, back to the start at the end. Held by
         hover, focus, any input on the rail, a background tab and reduced
         motion. */
      var autoMs = parseInt(row.getAttribute('data-h4-auto') || '0', 10);
      if (autoMs > 0) {
        var timer = null, held = false, cool;
        var canRun = function () { return window.innerWidth > 1024 && !document.hidden && !held && !reduce(); };
        var tick = function () {
          if (!canRun() || drag) return;
          if (row.scrollLeft >= maxX() - 2) glide(0, 0); else row.h4step(1);
        };
        var start = function () { if (!timer) timer = setInterval(tick, autoMs); };
        var halt = function () { clearInterval(timer); timer = null; };
        var hold = function (v) { held = v; if (v) halt(); else start(); };
        var nudge = function () { hold(true); clearTimeout(cool); cool = setTimeout(function () { hold(false); }, autoMs * 2); };
        row.addEventListener('mouseenter', function () { hold(true); });
        row.addEventListener('mouseleave', function () { nudge(); });
        ['wheel', 'pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { row.addEventListener(ev, nudge, { passive: true }); });
        $$('[data-h4-prev="' + row.id + '"], [data-h4-next="' + row.id + '"]').forEach(function (btn) { btn.addEventListener('click', nudge); });
        document.addEventListener('visibilitychange', function () { if (document.hidden) halt(); else if (canRun()) start(); });
        start();
      }
    });
  }

  function sprites() {
    var all = $$('[data-h4-icons]');
    for (var i = 1; i < all.length; i++) all[i].parentNode.removeChild(all[i]);
  }

  /* ---- labels a shopper can read --------------------------------------
     Two rewrites on the seller cards, and one lesson between them.

     "40 Ct" is warehouse language. The pack in the photograph beside it says
     100 TEA BAGS, and the shopper is choosing between a small box and a big
     one. Counts become what they count; weights and volumes are already plain.

     The subscribe row is built from a label and a cadence line, which is two
     lines for one offer on a 272px card. The saving is the headline, so it
     goes in the headline -- and it comes from Liquid on the card wrapper,
     because this card has no discount pill to read (the pill belongs to a
     different component, which is what the first attempt was hunting for).

     NEITHER PASS IS ONCE-ONLY. fgo-col-grid-js sets the size from the selected
     variant when it initialises, and it runs after this file -- so the first
     version marked the element as done and then watched its own work get
     overwritten. Both transforms are idempotent, so they simply run again once
     the card has settled, and again whenever a row is clicked. */
  function relabel(root) {
    $$('.sellers .fgColCardSize, .sellers .fgColOptMain, .sellers .fgColOptSub', root).forEach(function (el) {
      var was = el.textContent || '';
      var now = was.replace(/(\d+)\s*Ct\b/gi, function (_, n) {
        return n + ' tea bag' + (n === '1' ? '' : 's');
      });
      if (now !== was) el.textContent = now;
    });

    /* THE SUBSCRIBE ROW IS LEFT ALONE.

       It was being rewritten to one line because it wrapped at 252px. The
       cards are 276 now and the native row -- label, Save pill, cadence -- is
       the version Nate has pointed at as the best UI on the site three times.
       It is the same component; it only ever needed the width. */
  }

  function relabelSoon(root) {
    relabel(root);
    requestAnimationFrame(function () { relabel(root); });
    setTimeout(function () { relabel(root); }, 300);
    window.addEventListener('load', function () { relabel(root); });
    $$('.sellers', root).forEach(function (sec) {
      if (!once(sec, 'data-h4-relabel')) return;
      sec.addEventListener('click', function () { setTimeout(function () { relabel(sec); }, 0); });
    });
  }

  /* ---- the rail's progress track --------------------------------------
     Fill width is the visible fraction of the rail; its offset is how far
     along you are. Both are read from the element rather than counted in
     cards, so it stays honest whatever the card width ends up being. */
  function railBar(root) {
    $$('.sellers .cards', root).forEach(function (row) {
      var bar = $('[data-h4-railbar]', row.parentNode);
      if (!bar || !once(row, 'data-h4-bar')) return;
      var draw = function () {
        var max = row.scrollWidth - row.clientWidth;
        var frac = row.scrollWidth ? row.clientWidth / row.scrollWidth : 1;
        bar.style.width = Math.min(100, frac * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 / frac) - 1) * 100 : 0) + '%)';
        bar.parentNode.style.visibility = max > 2 ? 'visible' : 'hidden';
      };
      row.addEventListener('scroll', draw, { passive: true });
      window.addEventListener('resize', draw);
      draw();
    });
  }

  function bind(root) {
    sprites();
    relabelSoon(root);
    railBar(root);
    accordions(root);
    rows(root);
    carousels(root);
    nav(root);                 /* last: it asks the carousels whether they own their row */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target || document); });
})();
